// extracted by mini-css-extract-plugin
module.exports = {"spacer-main":"spacer_spacer-main__AQmAe","spacer-main--debug":"spacer_spacer-main--debug__EdZNB","spacer-main--small":"spacer_spacer-main--small__xAm2l"};